import * as React from "react";
import LexonComponentCalendar from "../../../apps/lexon_content_calendar";
import "./events.scss";

export class EventsImportV2 extends React.Component {
  constructor(props) {
    super(props);
    this.toasts = [];
  }

  componentDidMount() {}

  componentDidUpdate() {}

  render() {
    return (
      <div id="lexon-app-import-events" className="row custom-margin custom-padding-5 material2">
        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
          <div className="Ccontainer">
            <LexonComponentCalendar type="importEvents" />
          </div>
        </div>
      </div>
    );
  }
}

export default EventsImportV2;
